export default  {
    namespaced: true,
    state: {
      signupUser: {},
      haveAccessToSignup: false
    },
    mutations: {
        set_signupUser(state, signupUser) {
          if( signupUser ) {
              state.signupUser = signupUser
          }
        },
        reset_signup_user(state) {
            state.signupUser = {}
        },
        set_access_signup(state, haveAccessToSignup) {
          if( haveAccessToSignup !== null ) {
              state.haveAccessToSignup = haveAccessToSignup
          }
        },
    },
    actions: {
        SET_SIGNUP_USER({commit}, signupUser) {
          if( signupUser ) {
              commit('set_signupUser', signupUser)
          }
        },
        RESET_SIGNUP_USER({commit}) {
            commit('reset_signup_user')
        },
        SET_ACCESS_SIGNUP({commit}, haveAccessToSignup) {
          if( haveAccessToSignup !== null) {
              commit('set_access_signup', haveAccessToSignup)
          }
        },
    },
    getters: {
        get_signup_user: state => state.signupUser,
        get_access_signup: state => state.haveAccessToSignup
    }
}